(
    function (skyward, $)
    {
        var init = function (selector)
        {
            if ($(selector + ' #DetentionIncidentOffenseNameActionDetails').length > 0)
            {
                var browseName;
                var browse;
                var browseInitialFilter;
                var browseInitialRouteHash;

                var incidentOffenseNameActionDetailLookupHelper = function ()
                {
                    var studentID = $('#StudentID');
                    studentID.on("eelComplete", generateNameFilter);

                    setBrowseVariables();
                    generateNameFilter();
                };

                var generateNameFilter = function ()
                {
                    var tileViewEEL = $(this);

                    if (!tileViewEEL.hasClass('tileViewEEL'))
                    {
                        return;
                    }

                    $.ajax(
                    {
                        url: skyward.global.virtualDir + "Discipline/IncidentOffenseNameActionDetail/GenerateAddDetentionFilter",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            StudentID: skyward.controls.getValue(tileViewEEL)
                        },
                        success: function (data)
                        {
                            browse.data.filter = (data.SearchCondition) ? JSON.stringify(JSON.parse(data.SearchCondition)) : browseInitialFilter;
                            browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                            skyward.browse.get(browseName, {});
                        }
                    });

                };

                var setBrowseVariables = function ()
                {
                    browseName = skyward.browse.getCurrentBrowseName();
                    browse = skyward.browse.browseList[browseName];
                    browseInitialFilter = browse.data.filter;
                    browseInitialRouteHash = browse.routeHash;
                };

                incidentOffenseNameActionDetailLookupHelper();
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);